import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { RktIconComponent } from '@rocketfinancialcorp/rocket-ui/icon';

import { MoveHowSolutionItem, TransactionSolution } from '@shared/models';

@Component({
  selector: 'app-move-how-solution',
  templateUrl: './move-how-solution.component.html',
  styleUrls: ['./move-how-solution.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass, RktIconComponent],
})
export class MoveHowSolutionComponent {
  @Input() items: MoveHowSolutionItem[] = [];

  @Input() selectedItem?: TransactionSolution;

  @Input() disabledTypes: TransactionSolution[] = [];

  @Output() changed = new EventEmitter<TransactionSolution>();

  isDisabledType(type: TransactionSolution): boolean {
    return !!this.disabledTypes?.includes(type);
  }

  solutionTrackBy(_i: number, solution: MoveHowSolutionItem) {
    return solution.type;
  }

  onItemClick(type: TransactionSolution): void {
    if (this.selectedItem === type) {
      return;
    }

    this.changed.emit(type);
  }
}
